/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './UsersView.scss';

import BasePanel from '../../Panels';
import AddRole from '../../Panels/AddRole';
import AddLayerPermissions from '../../Panels/AddLayerPermissions';
import AddAttrPermissions from '../../Panels/AddAttrPermissions';
import AddFeaturePermissions from '../../Panels/AddFeaturePermissions';
import AddUser from '../../Panels/AddUser/AddUser';

class UsersView extends React.Component {
  render() {
    return (
      <div>
        <div className="col-sm-6">
          <BasePanel
            fullWidth
            user={this.props.user}
            userHasFeatureCode="0009"
            panelType="success"
            panelTitle="Dodaj/usuń role."
          >
            <AddRole />
          </BasePanel>
          <BasePanel
            fullWidth
            user={this.props.user}
            userHasFeatureCode="0009"
            panelType="success"
            panelTitle="Dodaj uprawnienia do atrybutów warstwy. "
          >
            <AddAttrPermissions />
          </BasePanel>

          <BasePanel
            fullWidth
            user={this.props.user}
            userHasFeatureCode="0009"
            panelType="danger"
            panelTitle="Dodaj konto urzędnika gminy. "
          >
          <AddUser />
          </BasePanel>       

        </div>
        <div className="col-sm-6">
          <BasePanel
            fullWidth
            user={this.props.user}
            userHasFeatureCode="0009"
            panelType="warning"
            panelTitle="Dodaj uprawnienia do warstwy. "
          >
            <AddLayerPermissions />
          </BasePanel>
          <BasePanel
            fullWidth
            user={this.props.user}
            userHasFeatureCode="0009"
            panelType="warning"
            panelTitle="Dodaj uprawnienia do funkcji systemu."
          >
            <AddFeaturePermissions />
          </BasePanel>
        </div>
      </div>
    );
  }
}

UsersView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(UsersView);



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/UsersView/UsersView.js